import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Space } from 'antd';
import { TriangleAlert } from 'lucide-react';
import Button from '../../../main/components/Button';
import Modal from '../../../main/components/Modal';
import GlobalContext from '../../../main/utils/GlobalContext';

const ConfirmationDeleteModal = ({
  visible,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const { locales } = useContext(GlobalContext);
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setErrors({});
  };

  const handleDelete = () => {
    if (!password) {
      setErrors({ password: 'Password is required' });
      return;
    }

    // If valid, call the onConfirm function
    onConfirm(password);
  };

  return (
    <Modal
      isOpen={visible}
      onClose={onClose}
      title={locales.account.confirmDeleteTitle}
    >
      <div className="confirmation-modal-delete">
        <Form layout="vertical">
          <div className="flex flex-col gap-1 mb-4">
            <p className="text-red-500 font-bold flex items-center gap-2">
              <TriangleAlert className="w-4 h-4" />
              {locales.admin.important}
            </p>
            <p>{locales.admin.confirmationDeleteWarningModal}</p>
          </div>

          <Form.Item
            label={locales.account.passwordConfirmationLabel}
            className="admin-input-label"
            validateStatus={errors.password ? 'error' : ''}
            help={errors.password}
          >
            <Input.Password
              placeholder={locales.account.passwordPlaceholder}
              className="admin-input"
              value={password}
              onChange={handlePasswordChange}
            />
          </Form.Item>
          <Space>
            <Button variant="outline" onClick={onClose}>
              {locales.common.cancel}
            </Button>
            <Button
              variant="destructiveOutline"
              disabled={loading}
              onClick={handleDelete}
            >
              {locales.common.deleteText}
            </Button>
          </Space>
        </Form>
      </div>
    </Modal>
  );
};

ConfirmationDeleteModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationDeleteModal;
